const initSnare = () => { // for hideBlackbox value while registering
  let s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = `/ci-mpsnare_iovation_com_snare.js`;
  document.body.appendChild(s);
}

export default initSnare;
